var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { injectTestId } from '@cvent/nucleus-test-automation';
import { AppleMapKit } from './AppleMapKit';
import { AppleMapWrapper } from './AppleMapWrapper';
export function AppleMap(props) {
    var address1 = props.address1, city = props.city, countryCode = props.countryCode, stateCode = props.stateCode, appleMapToken = props.appleMapToken, clickable = props.clickable, urlAddress = props.urlAddress;
    if (clickable) {
        return (React.createElement("a", __assign({}, injectTestId('apple-location-map-link'), { target: "_self", href: "http://maps.apple.com/?address=" + urlAddress }),
            React.createElement(AppleMapWrapper, { appleMapToken: appleMapToken },
                React.createElement(AppleMapKit, { address1: address1, city: city, stateCode: stateCode, countryCode: countryCode }))));
    }
    return (React.createElement("div", __assign({}, injectTestId('apple-location-map-link')),
        "``",
        React.createElement(AppleMapWrapper, { appleMapToken: appleMapToken },
            React.createElement(AppleMapKit, { address1: address1, city: city, stateCode: stateCode, countryCode: countryCode }))));
}
